import {createMuiTheme} from "@material-ui/core/styles";
import {makeStyles, withStyles} from "@material-ui/styles";
import Badge from "@material-ui/core/Badge";

export const StyledBadge = withStyles((theme) => ({
    badge: {
        right: -10,
        minWidth: "15px",
        height: "18px",
        color: "#222",
        backgroundColor: "#ffa900"
    },
}))(Badge);


export const textColors = createMuiTheme({
    palette: {
        primary: {
            main: "rgba(0, 0, 0, 0.87)",
        },
        secondary: {
            main: "#00b74a"
        },
    },
});


export const useClasses = makeStyles({
    pagination: {
        display: "flex",
        justifyContent: "flex-end",
    }

})
